import { render, staticRenderFns } from "./SidebarProfile.vue?vue&type=template&id=5251d4e0&scoped=true"
import script from "./SidebarProfile.vue?vue&type=script&lang=js"
export * from "./SidebarProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarProfile.vue?vue&type=style&index=0&id=5251d4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251d4e0",
  null
  
)

export default component.exports